import React from 'react';
import PropTypes from 'prop-types';

import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import CallToActionIcon from '@mui/icons-material/CallToAction';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import CloudIcon from '@mui/icons-material/Cloud';
import WindPowerIcon from '@mui/icons-material/WindPower';
import BlindsIcon from '@mui/icons-material/Blinds';
import LockIcon from '@mui/icons-material/Lock';
import MicIcon from '@mui/icons-material/Mic';
import AlarmIcon from '@mui/icons-material/Alarm';
import SecurityIcon from '@mui/icons-material/Security';
import PaletteIcon from '@mui/icons-material/Palette';
import HvacIcon from '@mui/icons-material/Hvac';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import TuneIcon from '@mui/icons-material/Tune';
import BoltIcon from '@mui/icons-material/Bolt';
import PowerIcon from '@mui/icons-material/Power';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CustomTooltip from '../shared/atoms/CustomTooltip';

const DefaultIcon = DeviceHubIcon;

// Actuator features icon map
const featureIconMap = {
  light: LightbulbIcon,
  humidity: ThermostatIcon,
  temperature: ThermostatIcon,
  contact: SensorDoorIcon,
  switch: PowerSettingsNewIcon,
  action: CallToActionIcon,
  voltage: BoltIcon,
  power: PowerSettingsNewIcon,
  current: BoltIcon,
  energy: PowerIcon,
  occupancy: SensorOccupiedIcon,
  smoke: CloudIcon,
  state: StarHalfIcon,
  brightness: BrightnessHighIcon,
  color_temp: TuneIcon,
  color: PaletteIcon,
  countdown: HourglassBottomIcon,
  power_outage_memory: PowerOffIcon,
  child_lock: ChildCareIcon,
  do_not_disturb: DoDisturbOnIcon,
  effect: AutoAwesomeIcon,
  color_power_on_behavior: PaletteIcon,
};

export const actuatorIconLibraryMap = {
  device: DefaultIcon,

  switch: PowerSettingsNewIcon,
  light: LightbulbIcon,
  color: PaletteIcon,

  climate: ThermostatIcon,
  hvac: HvacIcon,
  smoke: CloudIcon,
  fan: WindPowerIcon,

  cover: BlindsIcon,
  contact: SensorDoorIcon,

  occupancy: SensorOccupiedIcon,
  electrical: FlashOnIcon,
  gas: PropaneTankIcon,

  lock: LockIcon,
  security: SecurityIcon,
  alarms: AlarmIcon,

  voice: MicIcon,
};

export const getActuatorFeatureIcon = (exposes = [], name = '') => {
  if (name) return featureIconMap[name] ?? DefaultIcon;

  // if no name, get the first icon found in exposes if there's any
  const { type, property } =
    exposes.find(e => featureIconMap[e.type] || featureIconMap[e.property]) ??
    {};

  return featureIconMap[type] ?? featureIconMap[property] ?? DefaultIcon;
};

const ActuatorIcon = ({ exposes, name, type, tooltipLabel, ...props }) => {
  const Icon =
    type === 'library'
      ? actuatorIconLibraryMap[name] ?? DefaultIcon
      : getActuatorFeatureIcon(exposes, name);
  return (
    <CustomTooltip title={tooltipLabel}>
      <Icon {...props} />
    </CustomTooltip>
  );
};

ActuatorIcon.defaultProps = {
  exposes: [],
  name: '',
  tooltipLabel: '',
  type: 'feature',
};

export const actuatorIconPropTypes = {
  exposes: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string,
  type: PropTypes.oneOf(['library', 'feature']),
  tooltipLabel: PropTypes.string,
};

ActuatorIcon.propTypes = actuatorIconPropTypes;

export default ActuatorIcon;
